<template>
  <ComponentCard title="Big numbers" icon="solar:chart-square-linear">
    <BlockField :model-value="attrs.title" placeholder="Title (optional)" :read-only="readOnly" input-class="font-display text-base font-bold text-[#1c4848]" @update:model-value="set({ title: $event })" />
    <div class="grid grid-cols-2 gap-2 sm:grid-cols-3">
      <div v-for="(item, i) in attrs.items" :key="i" class="rounded-xl bg-[#1c4848]/[0.03] p-2">
        <BlockField :model-value="item.value" placeholder="17" :read-only="readOnly" input-class="font-display text-3xl font-bold text-[#1c4848]" @update:model-value="list.patch(i, { value: $event })" />
        <BlockField :model-value="item.label" placeholder="What it counts" :read-only="readOnly" input-class="text-xs text-[#1c4848]/80" @update:model-value="list.patch(i, { label: $event })" />
        <RowActions v-if="!readOnly" class="justify-end" :first="i === 0" :last="i === attrs.items.length - 1" @up="list.move(i, -1)" @down="list.move(i, 1)" @remove="list.remove(i)" />
      </div>
    </div>
    <button v-if="!readOnly" type="button" class="min-h-9 rounded-lg px-2 text-xs font-bold text-[#1c4848]/60 hover:bg-[#1c4848]/5 hover:text-[#1c4848]" @click="list.add({ value: '', label: '' })">+ Add a number</button>
  </ComponentCard>
</template>

<script setup>
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';
import RowActions from '@/components/writer/views/RowActions.vue';
import { useItems } from '@/components/writer/views/useItems.js';

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });
const list = useItems(props);
</script>
